
export default {
  data() {
    return {
      jumlah_penelitian : '',
      jumlah_riset : '',
      jumlah_krenova : '',
      jumlah_teknologi : '',
      jumlah_tema : '',
      jumlah_foto : '',
      jumlah_video : '',
      jumlah_aksi : '',
      alert: false,
      simpan1: false,
      model :'',
      inputSelect : [
        {id : '1', nama : 'kiken', alamat : 'beringin'},
        {id : '2',nama : 'Alung', alamat : 'Anawai'},
      ],
      date : '',
    }
  },
  methods: {

    getJumlahPenelitian : function(){
        fetch(this.$store.state.url.URL_Beranda + "penelitian", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_penelitian = res_data.data[0].jumlah_penelitian;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahKrenova : function(){
        fetch(this.$store.state.url.URL_Beranda + "krenova", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_krenova = res_data.data[0].jumlah_krenova;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahArtikel : function(){
        fetch(this.$store.state.url.URL_Beranda + "artikel", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_artikel = res_data.data[0].jumlah_artikel;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahAksi : function(){
        fetch(this.$store.state.url.URL_Beranda + "aksi", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_aksi = res_data.data[0].jumlah_aksi;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahTema : function(){
        fetch(this.$store.state.url.URL_Beranda + "tema", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_tema = res_data.data[0].jumlah_tema;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahTeknologi : function(){
        fetch(this.$store.state.url.URL_Beranda + "teknologi", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_teknologi = res_data.data[0].jumlah_teknologi;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahRiset : function(){
        fetch(this.$store.state.url.URL_Beranda + "riset", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_riset = res_data.data[0].jumlah_riset;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahVideo : function(){
        fetch(this.$store.state.url.URL_Beranda + "video", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_video = res_data.data[0].jumlah_video;
              // console.log(jumlah_pelaku);
        });
      },

      getJumlahFoto : function(){
        fetch(this.$store.state.url.URL_Beranda + "foto", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
        })
            .then(res => res.json())
            .then(res_data => {
              // console.log(res_data);
              this.jumlah_foto = res_data.data[0].jumlah_foto;
              // console.log(jumlah_pelaku);
        });
      },

    simulateProgress (number) {
      // we set loading state
      this[`simpan${number}`] = true
      // simulate a delay
      setTimeout(() => {
        // we're done, we reset loading state
        this[`simpan${number}`] = false
      }, 3000)
    },

    KehadiranPie : function(){
      Highcharts.chart('KehadiranPie', {
      chart: {
          type: 'pie',
          backgroundColor: 'transparent'
      },
      title: {
          text: 'DATA PRESENSI KEHADIRAN'
      },
      tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      accessibility: {
          point: {
              valueSuffix: '%'
          }
      },
      plotOptions: {
      pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
              enabled: false
          },
          showInLegend: true
      }
      },
      series: [{
          name: 'Persentase',
          colorByPoint: true,
          data: [
            {
              name: 'Hadir',
              y: 52.08,
              color:'#1e88e5',
              // sliced: true,
              // selected: true
            }, 
            {
              name: 'Izin',
              y: 22.92,
              color:'#7cb342',
            },
            {
              name: 'Tanpa Keterangan',
              y: 25.00,
              color:'#ff8a65',
            },
          
          ]
        }]
      });



    },

    KehadiranApelPie : function(){
      

      Highcharts.chart('KehadiranApelPie', {
      chart: {
          type: 'pie',
          backgroundColor: 'transparent',
          options3d: {
              enabled: true,
              alpha: 45,
              beta: 0
          }
      },
      title: {
          text: 'DATA PRESENSI APEL'
      },
      accessibility: {
          point: {
              valueSuffix: '%'
          }
      },
      tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
          pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              depth: 35,
              dataLabels: {
                  enabled: true,
                  format: '{point.name}'
              }
          }
          },
          series: [{
              type: 'pie',
              name: 'Persentase',
              data: [
                  {
                    name: 'Hadir',
                    y: 52.08,
                    color:'#1e88e5',
                    // sliced: true,
                    // selected: true
                  }, 
                  {
                    name: 'Izin',
                    y: 22.92,
                    color:'#7cb342',
                  },
                  {
                    name: 'Tanpa Keterangan',
                    y: 25.00,
                    color:'#ff8a65',
                  },
              ]
          }]
      });









    },



    

    async button(){
      await setTimeout(() => {
        console.log('ini query pembacaannya')
      }, 2000);
      console.log('telASO')
    }







  },

  mounted () {
    // this.KehadiranPie();
    // this.KehadiranApelPie();
    this.button();
    this.getJumlahPenelitian();
    this.getJumlahRiset();
    this.getJumlahKrenova();
    this.getJumlahAksi();
    this.getJumlahTema();
    this.getJumlahTeknologi();
    this.getJumlahFoto();
    this.getJumlahVideo();
  },
}
